import React from 'react'

// Button and Textfield removed - TagAutocomplete handles the UI
import { Box } from '@mui/material'

import TagAutocomplete from 'components/TagAutocomplete'

// theme removed - TagAutocomplete handles styling

export interface Tag {
  id: string
  name: string
  color?: string
}

interface TagsAddInputProps {
  value: Tag[]
  onChange: (tags: Tag[]) => void
  availableTags: Tag[]
  onCreateTag: (tagName: string) => Promise<Tag>
  onMarkFormAsDirty?: () => void
  disabled?: boolean
  maxTags?: number
  placeholder?: string
  // onFormStateChange removed - TagAutocomplete doesn't need form state tracking
}

// TagCreateForm removed - TagAutocomplete handles creation inline

const TagsAddInput: React.FC<TagsAddInputProps> = ({
  value,
  onChange,
  availableTags,
  onCreateTag,
  onMarkFormAsDirty,
  disabled = false,
  maxTags,
  placeholder
}) => {
  const handleCreateNewTag = async (tagName: string): Promise<Tag> => {
    const newTag = await onCreateTag(tagName)
    return newTag
  }

  return (
    <Box width="100%">
      <TagAutocomplete
        value={value}
        onChange={onChange}
        availableTags={availableTags}
        onCreateTag={handleCreateNewTag}
        onMarkFormAsDirty={onMarkFormAsDirty}
        disabled={disabled}
        maxTags={maxTags}
        placeholder={placeholder}
      />
    </Box>
  )
}

export default TagsAddInput
